/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';

import { LogoPlataform } from '../RowPlataform/styles';
import { DivTitleModal } from './styles';

export function BootstrapDialogTitle(props) {
  const { logo, children, onClose, ...other } = props;
  return (
    <DivTitleModal {...other}>
      <div>
        <LogoPlataform image={logo} />
        {children}
      </div>
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DivTitleModal>
  );
}
